import { render } from "./techDevPanel.vue?vue&type=template&id=439e275d"
import script from "./techDevPanel.vue?vue&type=script&lang=js"
export * from "./techDevPanel.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/public_web/selllogix-vuecli/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__